import styled from "styled-components";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const TooltipContainer = styled.div`
  // position: relative;
  // display: inline-block;
`;

const blueCol = "#123051";

export const TooltipText = styled.span`
  visibility: hidden;
  font-size: 10px;
  font-weight: 500;
  color: #123051;
  width: ${(props) => props.width || "190px"};
  background-color: #d4e2f2;
  text-align: center;
  border-radius: 6px;
  padding: 4px 8px 4px 8px;
  position: fixed;
  z-index: 1;
  bottom: ${(props) => props.bottom || "10%"};
  left: ${(props) => props.left || "75%"};
  margin-left: -210px;

  /* Tooltip arrow */
  //   &::after {
  //     content: "";
  //     position: absolute;
  //     top: 50%;
  //     left: 100%;
  //     margin-top: -5px;
  //     border-width: 5px;
  //     border-style: solid;
  //     border-color: transparent transparent transparent ${blueCol};
  //   }

  /* Show the tooltip text when hovering over the container */
  ${TooltipContainer}:hover & {
    visibility: visible;
  }
`;

export const InfoIcon = styled(InfoOutlinedIcon)`
  font-size: 20px;
  cursor: pointer;
`;
